import ComponentHeader from '../main/ComponentHeader';
import {Box, Input, InputGroup, InputLeftElement, Spacer, Text, Stack, useToast, Button, Table,Thead,Tbody,Tr,Th,Td,TableContainer} from '@chakra-ui/react'
import { SearchIcon, SmallAddIcon } from '@chakra-ui/icons';
import GruntComponents from '../components';
import { useState, useEffect } from 'react';
import { loggedOper as lp } from '../../util/grunt';
import GruntPager from '../custom/GruntPager';
import { getKlaonice, addKlaonica, updateKlaonica, Klaonica } from "../../util/apiKlaonica";
import KlaonicaControl from './KlaonicaControl';


const Klaonice = ({onClosePress,size='xs'}) => {
    const [state, setState] = useState({newklaonica:false,klaonice:[]});
    const [prikaz, setPrikaz] = useState({orderbycol:"id",orderby:"asc",klaoniceprikaz:[],rowsperpage:20,currpage:1, showKlaonica:false,selectedKlaonica:{},fetchklaonice:0});
    const userCanEdit=lp.uloga==="r"?false:true;
    const toast=useToast();
    const fetchKlaonice=async()=>{
        try {
            
            let res=await getKlaonice({orderbycolumn:state.orderbycol,orderby:state.orderby});
            if (res.status===200) {
                setState({...state,klaonice:res.res});        
                setPrikaz({...prikaz,klaoniceprikaz:res.res}); 
            } else {
                throw new Error(res.message);
            }
            
        } catch (error) {
            toast({
                title:"Greška kod dohvata podataka.",
                status:"error",
                description:error.message,
                isClosable:true,
                duration:2000,
                position:"top-right",
            });
        }
        
    }

    useEffect(() => {
        fetchKlaonice();
        
    }, [prikaz.fetchklaonice]);

    useEffect(() => {
        const Sort=()=>{
            const asc=prikaz.orderby==="asc";
            let _b;
            let _os=state.klaonice.sort((a,b)=>{
                if (prikaz.orderbycol==="sifra") {
                  _b=a.sifra>b.sifra;
                } else if (prikaz.orderbycol==="naziv") {
                    _b=a.naziv>b.naziv;
                } else if (prikaz.orderbycol==="mb") {
                    _b=a.mb>b.mb;
                } else if (prikaz.orderbycol==="oib") {
                    _b=a.oib>b.oib;
                } else if (prikaz.orderbycol==="mjesto") {
                    _b=a.mjesto>b.mjesto;
                } else if (prikaz.orderbycol==="ulkbr") {
                    _b=a.ulkbr>b.ulkbr;
                }

                return asc?(_b?1:-1):(_b?-1:1);
            });
            setPrikaz({...prikaz,klaoniceprikaz:_os}); 
        }
        Sort();
    }, [prikaz.orderbycol, prikaz.orderby]);

    const btnNew=()=>{
        if (userCanEdit) {
            return (
                <Button rightIcon={<SmallAddIcon/>} colorScheme={'grunt2'} variant={'outline'} size={size} 
                onClick={()=>newKlaonica()}>Dodaj</Button>
                )
        } else {
            return (
                <></>
                )
        }
    }

    const newKlaonica=()=>{
        const _kl=new Klaonica();
        setPrikaz({...prikaz,showKlaonica:true,selectedKlaonica:_kl})
    }
    const getOrderImage=(propname)=>{
        let _res=" ⋮";
        if (propname.toLowerCase()===prikaz.orderbycol){
            _res=" ▴"
            if (prikaz.orderby==="desc") {
                _res=" ▾"
            }
        } 
        return _res;
    }
    const ShowGruntPager=()=>{
        if (prikaz.klaoniceprikaz.length>0) {
            return (
                 <GruntPager currpage={prikaz.currpage} rowcount={prikaz.klaoniceprikaz.length} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
                 );    
                
        }
        
    }
    
    const FilterData=(filter)=>{
        const _val=filter.target.value.toLowerCase();
        let _o=state.klaonice.filter((klaonica)=>{
            return (klaonica.sifra.toLowerCase().includes(_val) || klaonica.mb.toLowerCase().includes(_val) || klaonica.oib.toLowerCase().includes(_val) ||  klaonica.naziv.toLowerCase().includes(_val) || klaonica.mjesto.toLowerCase().includes(_val) || klaonica.ulkbr.toLowerCase().includes(_val) || klaonica.opcina.toLowerCase().includes(_val));
        });
        setPrikaz({...prikaz,klaoniceprikaz:_o,currpage:1}); 
    }

    const getKlaonicaControl=()=>{
        if (prikaz.showKlaonica && prikaz.selectedKlaonica.id!==undefined) {
            return (
                <KlaonicaControl klaonica={prikaz.selectedKlaonica} readonly={!userCanEdit} onCloseControl={()=>setPrikaz({...prikaz,showKlaonica:false})} onSave={(kl)=>saveKlaonica(kl)}/>
            )
        }
    }
    const selectKlaonica=(kl)=>{
        const _kl=prikaz.klaoniceprikaz.find((item)=>item.id===kl);
        const _k= new Klaonica(_kl.id,_kl.sifra,_kl.oib,_kl.mb,_kl.naziv,_kl.mjesto,_kl.ulkbr,_kl.pbr,_kl.posta,_kl.opcina,_kl.zupanija);
        setPrikaz({...prikaz,selectedKlaonica:_k,showKlaonica:true});
    }
    const saveKlaonica=async (kl)=>{
       try {
            let res;
            if (kl.id===0) { //unos nove klaonice
                res=await addKlaonica(kl);
            } else { //ispravak podataka postojeće klaonice
                res=await updateKlaonica(kl);
            }
            if (res.status===200) {
 
                setPrikaz({...prikaz,showKlaonica:false,selectedKlaonica:{},fetchklaonice:prikaz.fetchklaonice+1})
                toast({
                    title:"Podatak spremljen",
                    status:"success",
                    isClosable:true,
                    duration:1500,
                    position:"top-right",
                });
            } else {
                if (res.code==="23505") {
                    throw new Error("Šifra klaonice već je iskorištena.");    
                } else {
                    throw new Error(res.message);
                }
            }
       } catch (ex) {
        toast({
            title:"Greška kod unosa",
            status:"error",
            description:ex.message,
            isClosable:true,
            duration:2000,
            position:"top-right",
        });
       }
    }
    const showBrZapis=()=>{
        return (
          <Text fontSize={'xs'}>Prikazano zapisa: {state.klaonice.length}</Text>
        )
      }
    const getFooter=()=>{
        return (
            
            <Box flexDir={'row'} display={'flex'} w="100%" marginTop={'1.5rem'}>
                
                <Box w="25%">
                    {showBrZapis()}
                </Box>
                <Box w="50%" textAlign={'left'}>
                    {ShowGruntPager()}
                </Box>
                <Box w="25%">
                    
                </Box>
            </Box>
            
        )
    }
    return (
        <Box h={'100%'} display={'flex'} flexDir={'column'} borderColor={'silver'} borderBottomRightRadius={'md'} borderWidth={'0.5px'} key='drzave_component' pl='0.5rem' pr={'0.5rem'} pb={'0.2rem'}>
            <ComponentHeader onClosePress={onClosePress} component={GruntComponents.Klaonice}/>
            <Box  display={'flex'} alignItems={'center'}>
                    <InputGroup size={size} w='20rem'>
                        <InputLeftElement pointerEvents={'none'} children={<SearchIcon/>}/>
                        <Input focusBorderColor='grunt2.400' placeholder='Filter' maxLength={'20'} onChange={FilterData}/>
                    </InputGroup>
                  
                    <Spacer/>
                    <Stack direction={'row'} spacing={'1rem'} mr={'1rem'}>
                        {btnNew()}
                    </Stack>
                    
            
                </Box>
                <Box display={'flex'} flexDir={'column'} flex={1}>
                <TableContainer overflowY={'auto'} mt={'0.5rem'}>
                    <Table variant={'unstyled'} size='sm'>
                        <Thead _hover={{cursor:'pointer'}}>
                            <Tr>
                                <Th w={'5%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} borderTopLeftRadius={'sm'}>Rbr</Th>
                                <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"sifra",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>Šifra{getOrderImage("sifra")}</Th>
                                <Th w={'30%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"naziv",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>Naziv{getOrderImage("naziv")}</Th>
                                <Th w={'7%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"mb",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>MB{getOrderImage("mb")}</Th>
                                <Th w={'7%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"oib",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>OIB{getOrderImage("oib")}</Th>
                                <Th w={'13%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"mjesto",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>Sjedište{getOrderImage("mjesto")}</Th>
                                <Th w={'13%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"ulkbr",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>Ulica{getOrderImage("ulkbr")}</Th>
                                
                            </Tr>
                        </Thead>
                        <Tbody>
                        {prikaz.klaoniceprikaz.slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage).map((item,i)=>{
                             return (
                                <Tr  color={'grunt2'} key={item.id}  bg={'white'} fontWeight={'normal'} 
                                _hover={{bg:'gray.100',cursor:'pointer'}} onClick={()=> selectKlaonica(item.id)} h='2rem'>
                                    <Td textAlign={'center'}>{((prikaz.currpage-1)*20)+ i+1}.</Td>
                                    <Td textAlign={'center'}>{item.sifra}</Td>
                                    <Td textAlign={'center'}>{item.naziv}</Td>
                                    <Td textAlign={'center'}>{item.mb}</Td>
                                    <Td textAlign={'center'}>{item.oib}</Td>
                                    <Td textAlign={'center'}>{item.mjesto}</Td>
                                    <Td textAlign={'center'}>{item.ulkbr}</Td>
                                </Tr>
                             )
                        })}
                        </Tbody>
                        </Table>
                </TableContainer>
                </Box>
                <Spacer/>
                {getKlaonicaControl()}
                {getFooter()}
            </Box>
    );
    
}

export default Klaonice;
